"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Escapes characters that can not be in an XML attribute.
 */
function escapeAttribute(value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}
exports.escapeAttribute = escapeAttribute;
//# sourceMappingURL=escape-attribute.js.map